/**
 * File view.js.
 *
 * Handles frontend scripts
 */
(function ($) {
	'use strict';

	// Get all elements with class '.slick-slider'
	const sliders = document.querySelectorAll( '.wp-block-md-opry-entertainment-addon-image-carousel .slick-slider' );

	// Loop through each slider and initialize Slick slider if not already initialized
	sliders.forEach( ( slider ) => {
		if ( ! slider.classList.contains( 'slick-initialized' ) ) {
			jQuery( slider ).slick();
		}
	} );
})(jQuery);
